import DimensionType from "./actionTypes"



// function that called as action
const getListPage = data => ({
  type: DimensionType.GET_DIMENSION_PAGES,
  payload: data,
})

// function to update state in reducer when fetching api is succeed or failed
const getListPageSuccess = data => ({
  type: DimensionType.GET_DIMENSION_PAGES_SUCCESS,
  payload: data,
})

// function that called as action
const getDetail = (data, action) => ({
  type: DimensionType.GET_DETAIL_DIMENSION_BY_ID,
  payload: data,
  action
})

// function to update state in reducer when fetching api is succeed or failed
const getDetailSuccess = data => ({
  type: DimensionType.GET_DETAIL_DIMENSION_BY_ID_SUCCESS,
  payload: data,
})

// function that called as action
const postData = (data, action) => ({
  type: DimensionType.POST_DIMENSION,
  payload: data,
  action
})

// function to update state in reducer when fetching api is succeed or failed
const postDataSuccess = data => ({
  type: DimensionType.POST_DIMENSION_SUCCESS,
  payload: data,
})

// function that called as action
const putData = (data, action) => {
  return {
    type: DimensionType.PUT_DIMENSION,
    payload: data,
    action
  }
}

// function to update state in reducer when fetching api is succeed or failed
const putDataSuccess = data => ({
  type: DimensionType.PUT_DIMENSION_SUCCESS,
  payload: data,
})


// function that called as action
const getList = data => ({
  type: DimensionType.GET_DIMENSION_LIST,
  payload: data,
})

// function to update state in reducer when fetching api is succeed or failed
const getListSuccess = data => ({
  type: DimensionType.GET_DIMENSION_LIST_SUCCESS,
  payload: data,
})

// function that called as action
const getListDimensionCategory = data => ({
  type: DimensionType.GET_DIMENSION_LIST_CATEGORY,
  payload: data,
})

// function to update state in reducer when fetching api is succeed or failed
const getListDimensionCategorySuccess = data => ({
  type: DimensionType.GET_DIMENSION_LIST_CATEGORY_SUCCESS,
  payload: data,
})

// function that called as action
const getListFrameType = data => ({
  type: DimensionType.GET_DIMENSION_FRAME_TYPE,
  payload: data,
})

// function to update state in reducer when fetching api is succeed or failed
const getListFrameTypeSuccess = data => ({
  type: DimensionType.GET_DIMENSION_FRAME_TYPE_SUCCESS,
  payload: data,
})


const DimensionAction = {
  getListPage,
  getListPageSuccess,

  getDetail,
  getDetailSuccess,

  postData,
  postDataSuccess,

  putData,
  putDataSuccess,

  getList,
  getListSuccess,

  getListDimensionCategory,
  getListDimensionCategorySuccess,

  getListFrameType,
  getListFrameTypeSuccess

}

export default DimensionAction





